import axios from 'axios';
import * as API_END_POINT from './constant';

const isResponseEmpty = (response) => {
    const data = response?.data?.data;
    return !data?.items?.length || data?.count === 0;
};

const buildOldApiPayload = (primaryPayload) => {
    const limit = primaryPayload?.limit || primaryPayload?.paging?.limit || 100;
    const offset = primaryPayload?.offset || primaryPayload?.paging?.offset || 0;

    return {
        paging: { limit, offset },
        sort: [{ fieldName: 'created_at', fieldOrder: 'DESC' }],
    };
};

export const fetchProductsWithFallback = async (primaryPayload) => {
    try {
        const primaryResponse = await axios.post(
            API_END_POINT.STORE_ALL_PRODUCTS,
            primaryPayload
        );

        if (!isResponseEmpty(primaryResponse)) {
            return primaryResponse;
        }

        console.warn('Primary API returned empty results, falling back to old API');
    } catch (error) {
        console.warn('Primary API failed, falling back to old API:', error.message);
    }

    const fallbackPayload = buildOldApiPayload(primaryPayload);
    const fallbackResponse = await axios.post(
        API_END_POINT.STORE_ALL_PRODUCTS_OLD,
        fallbackPayload
    );

    return fallbackResponse;
};
